import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  applicationId: "",
  debitCardProductId: "",
  success: "",
  error: "",
};

const OnlineBankingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ENABLE_ONLINE_BANKING:
      return {
        ...state,
        success: true,
        error: "",
        data: action.response,
      };
    case actionTypes.SET_ONLINE_BANKING:
      return {
        ...state,
        applicationId: action.data.applicationId,
        debitCardProductId: action.data.debitCardProductId,
        templateId: action.data.templateId,
      };
    default:
      return state;
  }
};

export default OnlineBankingReducer;
